import React from 'react';
import { Box, ButtonBase, Checkbox, Stack, Typography } from '@mui/material';
import type { FeatureFlagRolloutTargetControlProps } from '../../../types/features/featureFlags';
import { adminColors, adminTypography } from '../../../styles/adminDesignTokens';

const FeatureFlagRolloutTargetControl: React.FC<FeatureFlagRolloutTargetControlProps> = ({
  onChange,
  value,
}) => {
  const storeWiseSelected = value === 'store_wise';
  const userWiseSelected = value === 'user_wise';

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25}>
      <ButtonBase
        onClick={() => onChange('store_wise')}
        sx={{
          alignItems: 'flex-start',
          backgroundColor: storeWiseSelected ? adminColors.primarySoft : adminColors.surface,
          border: `1px solid ${storeWiseSelected ? adminColors.primary : adminColors.border}`,
          borderRadius: '8px',
          flex: 1,
          justifyContent: 'flex-start',
          minHeight: 74,
          p: 1.25,
          textAlign: 'left',
        }}
      >
        <Checkbox
          checked={storeWiseSelected}
          disableRipple
          inputProps={{ readOnly: true }}
          size="small"
          sx={{ color: adminColors.primary, mr: 1, p: 0.25 }}
          tabIndex={-1}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ ...adminTypography.bodyStrong, color: adminColors.text }}>
            Store Wise
          </Typography>
          <Typography sx={{ ...adminTypography.helper, color: adminColors.mutedText, mt: 0.5 }}>
            Assign access by store.
          </Typography>
        </Box>
      </ButtonBase>

      <ButtonBase
        onClick={() => onChange('user_wise')}
        sx={{
          alignItems: 'flex-start',
          backgroundColor: userWiseSelected ? adminColors.primarySoft : adminColors.surface,
          border: `1px solid ${userWiseSelected ? adminColors.primary : adminColors.border}`,
          borderRadius: '8px',
          flex: 1,
          justifyContent: 'flex-start',
          minHeight: 74,
          p: 1.25,
          textAlign: 'left',
        }}
      >
        <Checkbox
          checked={userWiseSelected}
          disableRipple
          inputProps={{ readOnly: true }}
          size="small"
          sx={{ color: adminColors.primary, mr: 1, p: 0.25 }}
          tabIndex={-1}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ ...adminTypography.bodyStrong, color: adminColors.text }}>
            User Wise
          </Typography>
          <Typography sx={{ ...adminTypography.helper, color: adminColors.mutedText, mt: 0.5 }}>
            Assign access by user.
          </Typography>
        </Box>
      </ButtonBase>
    </Stack>
  );
};

export default React.memo(FeatureFlagRolloutTargetControl);
